export default "__VITE_ASSET__ByBO$TJS__"